<script>
import { closest } from 'vue-xpc/src/utils/util.js';
export default {
  name: 'RtGlobalEditor',
  props: {
    vNode: [Array, String, Object, Number, Function],
    prop: String,
    row: Object,
    rules: [Array, String, Object, Function]
  },
  data () {
    return {
      editForm: {},
      componentName: ''
    };
  },
  mounted () {
    document.addEventListener('mouseup', this.handleClickOutside);
  },
  beforeDestroy () {
    document.removeEventListener('mouseup', this.handleClickOutside);
  },
  methods: {
    handleClickOutside (e) {
      const isInExact = !!(
        closest(e.target, '.rt-table-cell-editor') ||
        closest(e.target, '.rt-picklist-popper') ||
        closest(e.target, '.lookup-dialog')
      );
      if (!isInExact) {
        this.onValidate(() => {
          this.$emit('update');
        });
      }
    },
    onValidate (callback = null) {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          callback && callback();
        } else {
          this.$emit('validate-error');
        }
      });
    }
  },
  render (h) {
    let el = h('div');
    if (this.vNode) {
      const vNode =
        this.vNode({
          row: this.row
        })[0] || {};
      if (vNode.componentOptions) {
        this.componentName = vNode.componentOptions.Ctor.options.name;
        this.$set(this.editForm, this.prop, undefined);
        const changeFunc = [
          vNode.componentOptions.listeners &&
            vNode.componentOptions.listeners.change,
          val => {
            this.$set(this.editForm, this.prop, val);
          }
        ];
        const inputFunc = [
          vNode.componentOptions.listeners &&
            vNode.componentOptions.listeners.input,
          val => {
            this.$set(this.editForm, this.prop, val);
          }
        ];
        vNode.componentOptions.listeners = {
          ...vNode.componentOptions.listeners,
          change: changeFunc.filter(f => f),
          input: inputFunc.filter(f => f)
        };
        if (this.componentName === 'RtLookup') {
          const confirmFunc = [
            vNode.componentOptions.listeners &&
              vNode.componentOptions.listeners.confirm,
            val => {
              this.$set(this.editForm, this.prop, val);
              this.onValidate(() => {
                this.$emit('update');
              });
            }
          ];
          vNode.componentOptions.listeners = {
            ...vNode.componentOptions.listeners,
            confirm: confirmFunc.filter(f => f)
          };
        }
        el = vNode;
        this.editForm[this.prop] = this.row[this.prop];
        this.$setTimeout(() => {
          if (this.componentName === 'RtPicklist') {
            el.componentInstance && el.componentInstance.selectOption();
          } else {
            const ele = this.$refs.ruleForm.$el.getElementsByTagName(
              'input'
            )[0];
            ele.focus();
          }
        }, 100);
      }
    }
    return (
      <div>
        <rt-form
          class="rt-table-cell-editor-form"
          ref="ruleForm"
          model={this.editForm}
          rules={this.rules}
        >
          <rt-form-item prop={this.prop} hiddenLabel is-show-message={false}>
            {el}
          </rt-form-item>
        </rt-form>
      </div>
    );
  }
};
</script>



// WEBPACK FOOTER //
// rtTableCellEditor.vue?52a2612c